import React from 'react'
import { Col, Nav, NavItem, NavLink, TabContent, TabPane, Alert } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-spinner'
import Websocket from "react-websocket"
import classnames from 'classnames'

import { pageHelpers } from "../"
import { AppError, Team, UserConfirmationRequest } from '../../../models'
import { createField, deleteField, getTeam, inviteUser, updateField, updateTeam, getIntegrationForTeam, loadExternalTeams, disableJDOpsCenterIntegrationForTeam, WS_URL, environment } from "../../../api"
import { AddUserModal, EditableTeamHeader, FieldListTable, TeamMemberListTable, JDIntegrationPanel, AdminLinkBubble, ErrorMessage } from '../../ui'
import FieldIcon from 'react-icons/lib/fa/map-pin'
import TeamIcon from 'react-icons/lib/fa/group'
import AddOnIcon from 'react-icons/lib/fa/plug'

import '../../../stylesheets/Teams.css'

class ViewPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        pageHelpers.setupSingleRunAnimationEvents()
        const { token } = props

        let teamID = this.urlParams.team_id
        if (this.user && !teamID) {
            teamID = this.user.activeTeam
        }
        let activeTab = this.queryParams.tab || '1'

        this.state = {
            loading: false,
            memberListLoading: false,
            fieldListLoading: false,
            errors: [],
            userConfirmationRequests: [],
            activeTab,
            teamID,
            teamName: '',
            teamIsDealership: false,
            teamIsBetaTester: false,
            users: [],
            fields: [],
            integrations: [],
            addUserModalVisible: false,
            teamNameEditable: false,
            integrated: false,
            jdLoading: false,
            integration: null,
            integrationID: null,
            externalTeams: [],
            selectedExternalTeam: null,
            integrationFailure: null,
            token,
        }

        this.fetchTeam = this.fetchTeam.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.dismissUserConfirmationRequests = this.dismissUserConfirmationRequests.bind(this)

        this.handleRemoveUserEvent = this.handleRemoveUserEvent.bind(this)
        this.submitAddUserModal = this.submitAddUserModal.bind(this)
        this.updatePermissions = this.updatePermissions.bind(this)

        this.handleChangeTeamNameLinkClick = this.handleChangeTeamNameLinkClick.bind(this)
        this.updateTeamNameChange = this.updateTeamNameChange.bind(this)
        this.handleTeamNameSubmit = this.handleTeamNameSubmit.bind(this)
        this.switchTab = this.switchTab.bind(this)

        this.removeField = this.removeField.bind(this)
        this.addField = this.addField.bind(this)
        this.updateField = this.updateField.bind(this)

        this.handleIntegrateWithJDClick = this.handleIntegrateWithJDClick.bind(this)
        this.handleRemoveJDIntegrationClick = this.handleRemoveJDIntegrationClick.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)

        let { teamID, activeTab, teamName, users, } = this.state
        teamID = this.urlParams.team_id
        if (this.user && !teamID) {
            teamID = this.user.activeTeam
        }

        const { token } = nextProps
        activeTab = this.queryParams.tab || activeTab
        this.setState({ activeTab, token })
        if (teamID && teamID !== this.state.teamID && token) {
            this.setState({ loading: true, teamID })
            await this.fetchTeam()
            this.setState({ loading: false })
        } else if (token && teamID && (!teamName || !teamName.length || !users || !users.length)) {
            this.setState({ teamID, loading: true })
            await this.fetchTeam()
            this.setState({ loading: false })
        } else if (token && teamID) {
            this.setState({ teamID })
            await this.fetchTeam()
        }
    }

    async componentDidMount() {
        let { token, teamID, } = this.state
        if (token && teamID) {
            this.setState({ loading: true })
            await this.fetchTeam()
            this.setState({ loading: false })
        }
        //Displaying Integration Failure Error
        const urlParams = new URLSearchParams(window.location.search)
        const integrationFailure = urlParams.get('error')
        if(integrationFailure){
            this.setState({ integrationFailure: integrationFailure})
            console.log(integrationFailure)
        }

        //Handling JD Integration State
        try {
            const integration = await getIntegrationForTeam(teamID, token);
            if (integration) {
                this.setState({
                    integration: integration,
                    integrationID: integration.id,
                    loading: true,
                });
                this.setState({ loading: true })
                if (integration.has_access_token) {
                    this.setState({ externalTeams: await loadExternalTeams(integration.id, token) })
                    let { externalTeams } = this.state
                    const selectedExternalTeam = externalTeams.find(team => team.id === integration.selected_external_team);
                    if (selectedExternalTeam && selectedExternalTeam.connected) {
                        this.setState({ loading: false, integrated: true });
                    }
                    else {
                        await disableJDOpsCenterIntegrationForTeam(teamID, token);
                        this.setState({ loading: false, integrated: false });
                    }
                }
                else{
                    await disableJDOpsCenterIntegrationForTeam(teamID, token);
                    this.setState({ loading: false, integrated: false });
                }
            }
        } catch (error) {
            await disableJDOpsCenterIntegrationForTeam(teamID, token);
            window.location.reload();
        }
    }

    dismissUserConfirmationRequests() {
        this.setState({ userConfirmationRequests: [], loading: false, fieldListLoading: false })
    }

    async fetchTeam() {
        let { teamID, token } = this.state
        try {
            let team = await getTeam(token, teamID)
            this.setState({
                users: team.users,
                teamName: team.name,
                fields: team.fields,
                permissions: team.permissions,
                teamIsDealership: team.dealership,
                teamIsBetaTester: team.beta_tester,
            })
        } catch (error) {
            console.log(error)
        }
    }

    async submitAddUserModal(email) {
        let { token, teamID } = this.state
        return await inviteUser(token, email, teamID)
    }

    handleChangeTeamNameLinkClick() {
        this.setState({ teamNameEditable: true })
    }

    updateTeamNameChange(teamName) {
        this.setState({ teamName })
    }

    async handleTeamNameSubmit(event, values) {
        event.preventDefault()
        let { teamID, token } = this.state
        let oldTeamName = this.state.teamName
        let { teamName } = values
        try {
            let team = { id: teamID, name: teamName }
            await updateTeam(token, team)
            this.setState({ teamNameEditable: false })
        } catch (err) {
            console.log(err)
            this.setState({ teamNameEditable: false, teamName: oldTeamName })

            if (err && err.message && err.message.includes('name already exists')) {
                let error = new AppError('Invalid Team Name', `A team named ${teamName} already exists. Please choose another name.`)
                this.setState({ errors: [error] })
            } else {
                throw err
            }
        }
    }


    handleWebSocketResponse(data) {
        let team = Team.fromAPIObject(JSON.parse(data))
        let teamName = team.name
        let fields = team.fields
        let permissions = team.permissions
        let users = team.users.sort((a, b) => (a.name > b.name ? 1 : -1))
        let teamIsDealership = team.dealership
        let teamIsBetaTester = team.beta_tester
        this.setState({ teamName, users, fields, permissions, teamIsDealership, teamIsBetaTester, })
    }

    async switchTab(tab) {
        let { activeTab } = this.state
        if (activeTab !== tab) {
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?tab=${tab}`
            })
        }
    }

    async removeField(fieldID) {
        let { fields, token } = this.state
        this.setState({ fieldListLoading: true })
        try {
            await deleteField(token, fieldID)
            fields = fields.filter((f) => f.id !== fieldID)
        } catch (err) {
            console.log(err)
            let error = new AppError('Unable to Remove Field', `There was an error removing this field. Please try again in a few minutes`)
            this.setState({ errors: [error] })
        } finally {
            this.setState({ fields, fieldListLoading: false })
        }
    }

    async addField(values) {
        let { fields, teamID, token } = this.state
        this.setState({ fieldListLoading: true })

        try {
            let field = await createField(token, values.field_number, values.name, teamID)
            fields = fields.concat(field)
        } catch (err) {
            console.log(err)
            let error = new AppError('Unable to Add Field', `There was an error adding this field. Please try again in a few minutes`)
            if (err.message) {
                if (JSON.parse(err.message).non_field_errors) {
                    error = new AppError('Unable to Add Field', `A new field's number cannot match another field in your team.`)
                }
            }
            this.setState({ errors: [error] })
        } finally {
            this.setState({ fields, fieldListLoading: false })
        }
    }

    async updateField(field) {
        this.setState({ fieldListLoading: true })
        let confirm = async (event = null) => {
            try {
                let { fields, teamID, token } = this.state
                field.team = parseInt(teamID)
                let newField = await updateField(token, field)
                fields = fields.map((f) => {
                    if (parseInt(f.id) === parseInt(field.id)) {
                        return newField
                    }
                    return f
                })
                this.setState({ fields })
            } catch (err) {
                console.log(err)
                let error = new AppError('Unable to Update Field', `There was an error updating this field. Please try again in a few minutes`)
                if (err.message) {
                    if (JSON.parse(err.message).non_field_errors) {
                        error = new AppError('Unable to Update Field', `Field number cannot match another field in your team.`)
                    }
                }
                this.setState({ errors: [error] })
            } finally {
                this.setState({ fieldListLoading: false })
                this.dismissUserConfirmationRequests()
            }
        }

        let { fields } = this.state

        let newFieldNumber = field.field_number
        let oldField = fields.filter(f => f.id === field.id)
        let oldFieldNumber = "None"
        if (oldField && oldField.length) {
            oldFieldNumber = oldField[0].field_number
        }

        if (oldFieldNumber !== newFieldNumber) {
            let confirmationRequest = new UserConfirmationRequest('Update Field',
                `Any controllers in field <strong>${field.name || field.field_number}</strong> will be updated from <strong>${oldFieldNumber}</strong> to <strong>${newFieldNumber}</strong> when they come online. Do you want to continue?`,
                confirm,
                this.dismissUserConfirmationRequests,
                null)
            this.setState({ userConfirmationRequests: [confirmationRequest] })
        } else {
            await confirm()
        }
    }

    async updatePermissions(users) {
        let { permissions, teamID, token } = this.state
        this.setState({ memberListLoading: true })

        users.map(user => {
            let userPermission = permissions.filter(p => `${p.user}` === `${user.id}`)[0]
            userPermission.permissions = user.permissions.filter(p => `${p.team}` === `${teamID}`)[0].permissions
            permissions = permissions.filter(p => `${p.user}` !== `${user.id}`).concat(userPermission)
        })
        let team = { id: teamID, permissions }

        try {
            let newTeam = await updateTeam(token, team)
            let users = newTeam.users.sort((a, b) => (a.name > b.name ? 1 : -1))
            this.setState({ users, permissions })
        } catch (err) {
            console.log(err)
            let error = new AppError('Unable to Update Permissions', `There was an error updating team permissions. Please try again in a few minutes`)
            this.setState({ errors: [error] })
        } finally {
            this.setState({ memberListLoading: false })
        }
    }

    handleRemoveUserEvent(user) {
        let confirm = async (event) => {
            let { teamID, token } = this.state
            this.setState({ memberListLoading: true })
            try {
                let team = { id: teamID }
                let newTeam = await updateTeam(token, team, user.id)
                this.setState({ users: newTeam.users, permissions: newTeam.permissions, teamName: newTeam.name })
            } catch (err) {
                console.log(err)
                let error = new AppError('Unable to Remove User', `There was an error removing ${user.name}. Please try again in a few minutes`)
                this.setState({ errors: [error] })
            } finally {
                this.setState({ memberListLoading: false, userConfirmationRequests: [] })
            }
        }

        let confirmationRequest = new UserConfirmationRequest('Remove User',
            `Are you sure you want to remove ${user.name} from the team?`,
            confirm,
            this.dismissUserConfirmationRequests,
            user)
        this.setState({ userConfirmationRequests: [confirmationRequest] })
    }

    //New John Deere Integration Functions
    async handleIntegrateWithJDClick() {
        this.setState({ jdLoading: true, integrateButton: false });
        let { teamID, token } = this.state;
        await this.initiateOAuthProcess(teamID, token);
    }

    async initiateOAuthProcess(teamID, token) {
        this.setState({ integrateButton: false });
        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token.accessToken}`);
        headers.append('Content-Type', 'application/json');
        try {
            let endpoint = `${environment.API_URL}/integrations/jdo/`;
            let response = await fetch(endpoint, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ team: teamID })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();
            // Redirect to the authorization_url to start the OAuth2 process
            window.location.href = data.authorization_url;
        } catch (error) {
            console.error("A fetch error occurred: ", error);
        }
    }

    async handleRemoveJDIntegrationClick() {
        let { teamID, token } = this.state
        await disableJDOpsCenterIntegrationForTeam(teamID, token)
        this.setState({ integrated: false })
    }

    render() {
        let {
            errors, teamNameEditable, teamName, teamID, fields, users, userConfirmationRequests, memberListLoading,
            loading, addUserModalVisible, activeTab, teamIsDealership, teamIsBetaTester, jdLoading,
            fieldListLoading, token, integrateButton, integrated, integrationFailure
        } = this.state

        return (loading ? <Loader type="TailSpin" color="orange" width={60} height={60} /> :
            <div className="m-0 p-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '1' })}
                            onClick={() => {
                                this.switchTab('1')
                            }}>
                            <TeamIcon className="mr-1 mr-sm-2" />Members
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === '2' })}
                            onClick={() => {
                                this.switchTab('2')
                            }}>
                            <FieldIcon className="mr-1 mr-sm-2" />Fields
                        </NavLink>
                    </NavItem>
                    {/* {teamIsBetaTester ? */}
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === '3' })}
                                onClick={() => {
                                    this.switchTab('3')
                                }}>
                                <AddOnIcon className="mr-1 mr-sm-2" />Integrations
                            </NavLink>
                        </NavItem> 
                        {/* : null} */}
                </Nav>
                <Col xs={12}
                    className="bg-light large-rounded border-light-sf-orange justify-content-center p-0">
                    <EditableTeamHeader editing={teamNameEditable} teamName={teamName}
                        teamIsDealership={teamIsDealership} onSubmit={this.handleTeamNameSubmit} />
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <TeamMemberListTable users={users}
                                currentUserID={(this.user ? this.user.id : -1)}
                                currentUserIsSupport={this.user && this.user.isSupport}
                                loading={memberListLoading}
                                onAddUserClicked={() => {
                                    this.setState({ addUserModalVisible: true })
                                }}
                                onRemoveUserClicked={this.handleRemoveUserEvent}
                                onSavePermissions={this.updatePermissions} />
                        </TabPane>
                        <TabPane tabId="2">
                            <FieldListTable fields={fields}
                                loading={fieldListLoading}
                                onAddField={this.addField}
                                onRemoveField={this.removeField}
                                onUpdateField={this.updateField} />
                        </TabPane>
                        {/* {teamIsBetaTester ? */}
                            <TabPane tabId="3">
                                {integrationFailure ? <ErrorMessage
                                    text={integrationFailure + ". Please try again."}
                                    title={"Integration Failed"}/> : null}
                                {/* <Alert color="warning" className="pulse">This feature is only available for beta user testing.</Alert> */}
                                <h2 className="mt-4">Integrations</h2>
                                <hr />
                                <p className="sf-blue">Get even more out of your Marksman by integrating your team with third-party products.</p>
                                <JDIntegrationPanel 
                                    integrated={integrated}
                                    loading={jdLoading}
                                    integrateButton={integrateButton}
                                    onIntegrateWithJDClick={this.handleIntegrateWithJDClick}
                                    onRemoveIntegrationClick={this.handleRemoveJDIntegrationClick}
                                />
                            </TabPane> 
                            {/* : null} */}
                    </TabContent>
                </Col>

                {teamID && this.user && this.user.isSupport ?
                    <AdminLinkBubble url={`marksman_api/team/${teamID}`}
                        modelName="Team"
                        className="mt-2" /> :
                    null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
                {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}

                {(addUserModalVisible ?
                    <AddUserModal close={() => this.setState({ addUserModalVisible: false })}
                        teamName={teamName}
                        submit={this.submitAddUserModal} />
                    : null
                )}
                {(teamID && token ?
                    <Websocket url={`${WS_URL}/teams/${teamID}/?access_token=${token.accessToken}`}
                        onMessage={this.handleWebSocketResponse} /> : null)}
            </div>
        )
    }
}

export default withRouter(ViewPage)



// WEBPACK FOOTER //
// ./src/components/pages/teams/ViewPage.js